import { action } from 'typesafe-actions';
import { Types } from './types';

export const initializeObservability = () =>
  action(Types.SET_OBSERVABILITY_INITIALIAZED);
export const initializeObservabilitySuccess = () =>
  action(Types.SET_OBSERVABILITY_INITIALIAZED_SUCCESS);
export const observabilityError = (error: unknown) =>
  action(Types.OBSERVABILITY_ERROR, {}, {}, error);

export enum RcaKind {
  DownloadItem = 'di'
}

export const sendRcaLogs = (
  rcaKind: RcaKind,
  resourceType: string,
  resourceId: string | number
) =>
  action(Types.OBSERVABILITY_RCA_SEND_LOGS, {
    rcaKind,
    resourceId: resourceId.toString(),
    resourceType
  });
